/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import {TASK_MASTER,PROJECT_MANAGEMENT_MASTERS,CODE_COVERAGE,TEST_MASTER } from '../resources/endPoint';

export const getTaskData = () => {
  return {
    url: TASK_MASTER,
    method: 'get',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const editTaskData = (data) => {
  return {
    url: TASK_MASTER,
    method: 'put',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
    payload: data,
  };
};

export const deleteTaskData = (id,token) => {
  let url = `${TASK_MASTER}?id=${id}`;

  return {
    url: url,
    method: 'delete',
    headers: { 'content-type': 'application/json'},token: token, 
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const addTaskData = (data) => {     
  return {
    url: TASK_MASTER,
    method: 'post',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
    payload: data,
  };
}

export const getProjectManagementData = () => {
  return {
    url: PROJECT_MANAGEMENT_MASTERS,
    method: 'get',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const editProjectManagementData = (data) => {
  return {
    url: PROJECT_MANAGEMENT_MASTERS,
    method: 'put',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
    payload: data,
  };
};

export const deleteProjectManagementData = (id,token) => {
  let url = `${PROJECT_MANAGEMENT_MASTERS}?id=${id}`;

  return {
    url: url,
    method: 'delete',
    headers: { 'content-type': 'application/json'},token: token, 
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const addProjectManagementData = (data) => {     
  return {
    url: PROJECT_MANAGEMENT_MASTERS,
    method: 'post',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
    payload: data,
  };
}

export const getCodeCoverageData = () => {
  return {
    url: CODE_COVERAGE,
    method: 'get',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const editCodeCoverageData = (data) => {
  return {
    url: CODE_COVERAGE,
    method: 'put',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
    payload: data,
  };
};

export const deleteCodeCoverageData = (id,token) => {
  let url = `${CODE_COVERAGE}?id=${id}`;

  return {
    url: url,
    method: 'delete',
    headers: { 'content-type': 'application/json'},token: token, 
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const addCodeCoverageData = (data) => {     
  return {
    url: CODE_COVERAGE,
    method: 'post',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
    payload: data,
  };
}

export const getTestData  = () => {
  return {
    url: TEST_MASTER,
    method: 'get',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const editTestData = (data) => {
  return {
    url: TEST_MASTER,
    method: 'put',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
    payload: data,
  };
};

export const deleteTestData = (id,token) => {
  let url = `${TEST_MASTER}?id=${id}`;

  return {
    url: url,
    method: 'delete',
    headers: { 'content-type': 'application/json'},token: token, 
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const addTestData = (data) => {     
  return {
    url: TEST_MASTER,
    method: 'post',
    headers: { 'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
    payload: data,
  };
}